<div style="height: 90vh;">
  <app-top-bar></app-top-bar>
  <router-outlet></router-outlet>

  <footer class="w-full absolute bottom-5 text-center">
    Powered by &copy; <a href="https://www.explect.com" class="text-info" target="_blank">Explect</a>
  </footer>
</div>
